import { SchemaOf, number, object } from 'yup';

import { Price } from '../interface';
import { CreateAlertForm, createAlertSchema } from './alert';

export type UpdateProductAlertForm = {
  amount: number;
};

export type CreateProductAlertForm = CreateAlertForm<UpdateProductAlertForm>;

export const getPostProductAlertSchema = (totalPrice: Price): SchemaOf<CreateProductAlertForm> =>
  createAlertSchema({
    amount: number().positive().max(totalPrice).required(),
  });

export const getUpdateProductAlertSchema = (totalPrice: Price): SchemaOf<UpdateProductAlertForm> =>
  object().shape({
    amount: number().positive().max(totalPrice).required(),
  });
